import React, { useState, useEffect, useMemo } from "react";

import DateTimePicker from "./DateTimePicker.js";
import MultiSelect from "./MultiSelect.js";
import FourthCollapsibleTable from "./tables/FourthCollapsibleTable.js";

//loaders
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";

import { excelAFecha  } from "../functions/functions.js";

import { Box, Button } from "@mui/material";
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import { MainButton } from "../SXStyle.jsx";
import * as XLSX from "xlsx";

function FourthDynamicTable({ visible, dataExcel, openLoader, setOpenLoader }) {
  
  //catalogos
  const [movimientos, setMovimientos] = useState([]);
  const [desarrollos, setDesarrollos] = useState([]);
  const [materiales, setMateriales] = useState([]);

  //result
  const [finalData, setFinalData] = useState([]);
  const [resumenPonderados, setResumenPonderados] = useState([]);

  //filtros
  const [filtrosSeleccionados, setFiltrosSeleccionados] = useState({
    fecha: null,
    fechaInicio: null,
    fechaFinal: null,
    strfechaInicio: "",
    strfechaFinal: "",
    movimientos: [],
    materiales: [],
    desarrollos: [],
  });

  const dataMovimientos = [
    "01_MINERAL_TUMBADO",
    "03_PRODUCCION_TEPETATE",
    "02_PRODUCCION",
    "04_REMANEJO",
    "05_ALIMENTACION",
    "06_MOVIMIENTO BANDA",
    "06_ENTRADA A MHS",
  ];

  const dataMateriales = [
    "INCREMENTAL",
    "MINERAL",
    "TEPETATE",
    "SUBINCREMENTAL"
  ];

  const dataDesarrollos = [
    "DESARROLLO VERTICAL",
    "DESARROLLO LATERAL",
    "DESBORDE",
    "DESCABECE",
    "ENCAPILLE",
    "MIL_CRT_0885_36",
    "PRODUCCION BL",
    "MHS"
  ];
  

  //agrupa por fechas y calcula ponderados
  useEffect(() => {
    if (dataExcel.length > 0) {
      fetchExcel();
      setOpenLoader(false);
    }
  }, [dataExcel]);

  const fetchExcel = async () => {
    try {
      //agrupa por fechas
      let preResult = agruparPorFechaDestinoOrigen(dataExcel);

      //calcula los ponderados
      const datosPonderados = ponderadosCalculadosPorFechaDestinoOrigen(preResult);
      setFinalData(datosPonderados);

      //calcula el resumen de los ponderados
      setResumenPonderados(resumenPonderadosCalculados(datosPonderados));

    } catch (err) {
      console.error(err);
    }
  };


  //filtra la informacion
  useEffect(() => {
    if (dataExcel.length === 0) return;
    
    if(filtrosSeleccionados.length === 0) return;

    setOpenLoader(true);
    
    // Dejamos tiempo para que el loader se muestre antes del procesamiento
    setTimeout(() => {
      //Rango de fechas
      const fechaInicio = filtrosSeleccionados.fechaInicio;
      const fechaFinal = filtrosSeleccionados.fechaFinal;
      
      // Filtra la informacion
      const resultDatosFiltrados = dataExcel.filter(row => {
      
        const fechaExcel = row[2];    //filtro de fechas
        const tipoDesarrollo = row[6]; //filtro de desarrollo
        const tipoMaterial = row[14]  //filtro material
        const tipoMovimiento = row[4] //filtro movimiento
        
        //aplica el filtro de fechas
        const fechasFiltradas = fechaInicio == null || fechaFinal == null || (fechaExcel >= fechaInicio && fechaExcel <= fechaFinal);

        //aplica el filtro de desarrollo
        const desarrollosFiltrados = filtrosSeleccionados.desarrollos?.length == 0 || filtrosSeleccionados.desarrollos.includes(tipoDesarrollo);
     
        //aplica el filtro de materiales
        const materialesFiltrados = filtrosSeleccionados.materiales?.length == 0 || filtrosSeleccionados.materiales.includes(tipoMaterial);

        //aplica el filtro de movimiento
        const movimientosFiltrados = filtrosSeleccionados.movimientos?.length == 0 || filtrosSeleccionados.movimientos.includes(tipoMovimiento);

        return fechasFiltradas && desarrollosFiltrados && materialesFiltrados && movimientosFiltrados;
      });

      //agrupa por fechas
      let preResult = agruparPorFechaDestinoOrigen(resultDatosFiltrados);
      const datosPonderados =  ponderadosCalculadosPorFechaDestinoOrigen(preResult);
      setFinalData(datosPonderados);

      //calcula el resumen de los ponderados
      setResumenPonderados(resumenPonderadosCalculados(datosPonderados));

      setOpenLoader(false);
      
    }, 0); // Deja que se renderice el loader primero
    
  }, [filtrosSeleccionados]);



  function agruparPorFechaDestinoOrigen(dataLista) {
    const agrupado = {};

    // Filtrar solo los destinos deseados
    const arrayDestinos = dataLista.filter(
      (item) =>
        item[9] === "MHS_RB1_OP7" ||
        item[9] === "MHS_RB1_OP7 / 08" ||
        item[9] === "MHS_RB4_OP8" ||
        item[9] === "MLL_ETC" ||
        item[9] === "MLL_ETC_0684_01/MHS_RB1_OP7"
    );

    arrayDestinos.forEach((registro) => {
      const serialFecha = registro[2];
      const fechas = excelAFecha(serialFecha);

      const destinos = registro[9];
      const origenes = registro[7];

      if (!agrupado[fechas]) {
        agrupado[fechas] = {
          Etiquetas_de_fila: fechas,
          Toneladas: "pendiente",
          AuEq_Gr_t: "pendiente",
          Au_Gr_t: "pendiente",
          Ag_gr_t: "pendiente",
          Cu_pct: "pendiente",
          Fe_pct: "pendiente",
          S_pct: "pendiente",
          As_pct: "pendiente",
          Bi_ppm: "pendiente",
          Cd_ppm: "pendiente",
          Zn_pct: "pendiente",
          AuEq_Oz: "pendiente",
          dataDestinos: [], // agruparemos por destinos aqui
        };
      }

      if (!agrupado[fechas].dataDestinos[destinos]) {
        agrupado[fechas].dataDestinos[destinos] = {
          Destinos: destinos,
          Toneladas: "pendiente",
          AuEq_Gr_t: "pendiente",
          Au_Gr_t: "pendiente",
          Ag_gr_t: "pendiente",
          Cu_pct: "pendiente",
          Fe_pct: "pendiente",
          S_pct: "pendiente",
          As_pct: "pendiente",
          Bi_ppm: "pendiente",
          Cd_ppm: "pendiente",
          Zn_pct: "pendiente",
          AuEq_Oz: "pendiente",
          dataOrigenes: [],
        };
      }

      if (!agrupado[fechas].dataDestinos[destinos].dataOrigenes[origenes]) {
        agrupado[fechas].dataDestinos[destinos].dataOrigenes[origenes] = {
          Origenes: origenes,
          Toneladas: "pendiente",
          AuEq_Gr_t: "pendiente",
          Au_Gr_t: "pendiente",
          Ag_gr_t: "pendiente",
          Cu_pct: "pendiente",
          Fe_pct: "pendiente",
          S_pct: "pendiente",
          As_pct: "pendiente",
          Bi_ppm: "pendiente",
          Cd_ppm: "pendiente",
          Zn_pct: "pendiente",
          AuEq_Oz: "pendiente",
          registros: [],
        };
      }

      //agrupado[fechas].dataDestinos[destinos].dataOrigenes.push(registro);
      agrupado[fechas].dataDestinos[destinos].dataOrigenes[origenes].registros.push(registro);
    });

    // Convertimos a array final
    return Object.values(agrupado).map((grupoDes) => {
      return {
        Etiquetas_de_fila: grupoDes.Etiquetas_de_fila,
        Toneladas: grupoDes.Toneladas,
        AuEq_Gr_t: grupoDes.AuEq_Gr_t,
        Au_Gr_t: grupoDes.Au_Gr_t,
        Ag_gr_t: grupoDes.Ag_gr_t,
        Cu_pct: grupoDes.Cu_pct,
        Fe_pct: grupoDes.Fe_pct,
        S_pct: grupoDes.S_pct,
        As_pct: grupoDes.As_pct,
        Bi_ppm: grupoDes.Bi_ppm,
        Cd_ppm: grupoDes.Cd_ppm,
        Zn_pct: grupoDes.Zn_pct,
        AuEq_Oz: grupoDes.AuEq_Oz,
        dataDestinos: Object.values(grupoDes.dataDestinos || {}).map(
          (grupoDestino) => ({
            Destinos: grupoDestino.Destinos,
            Toneladas: grupoDestino.Toneladas,
            AuEq_Gr_t: grupoDestino.AuEq_Gr_t,
            Au_Gr_t: grupoDestino.Au_Gr_t,
            Ag_gr_t: grupoDestino.Ag_gr_t,
            Cu_pct: grupoDestino.Cu_pct,
            Fe_pct: grupoDestino.Fe_pct,
            S_pct: grupoDestino.S_pct,
            As_pct: grupoDestino.As_pct,
            Bi_ppm: grupoDestino.Bi_ppm,
            Cd_ppm: grupoDestino.Cd_ppm,
            Zn_pct: grupoDestino.Zn_pct,
            AuEq_Oz: grupoDestino.AuEq_Oz,
            dataOrigenes: Object.values(grupoDestino.dataOrigenes || {}).map(
              (grupoOrigen) => ({
                Origenes: grupoOrigen.Origenes,
                Toneladas: grupoOrigen.Toneladas,
                AuEq_Gr_t: grupoOrigen.AuEq_Gr_t,
                Au_Gr_t: grupoOrigen.Au_Gr_t,
                Ag_gr_t: grupoOrigen.Ag_gr_t,
                Cu_pct: grupoOrigen.Cu_pct,
                Fe_pct: grupoOrigen.Fe_pct,
                S_pct: grupoOrigen.S_pct,
                As_pct: grupoOrigen.As_pct,
                Bi_ppm: grupoOrigen.Bi_ppm,
                Cd_ppm: grupoOrigen.Cd_ppm,
                Zn_pct: grupoOrigen.Zn_pct,
                registros: grupoOrigen.registros || []
              })
            ),
          })
        ),
      };
    });
  }

  //calcula los ponderamos de cada fecha  - destino - origen
  function ponderadosCalculadosPorFechaDestinoOrigen(agrupado) {
    const resultado = [];

    Object.entries(agrupado).forEach(([fechaKey, grupoFecha]) => {
      const destinosCalculados = [];

      let totalToneladasFecha = 0;
      let sumAuEq_Gr_tFecha = 0;
      let sumAu_Gr_tFecha = 0;
      let sumAg_gr_tFecha = 0;
      let sumCu_pctFecha = 0;
      let sumFe_pctFecha = 0;
      let sumS_pctFecha = 0;
      let sumAs_pctFecha = 0;
      let sumBi_ppmFecha = 0;
      let sumCd_ppmFecha = 0;
      let sumZn_pctFecha = 0;
      let sumAuEq_OzFecha = 0;

      Object.entries(grupoFecha.dataDestinos || {}).forEach(
        ([destinoKey, grupoDestino]) => {
          const origenesCalculados = [];

          let totalToneladasDestino = 0;
          let sumAuEq_Gr_tDestino = 0;
          let sumAu_Gr_tDestino = 0;
          let sumAg_gr_tDestino = 0;
          let sumCu_pctDestino = 0;
          let sumFe_pctDestino = 0;
          let sumS_pctDestino = 0;
          let sumAs_pctDestino = 0;
          let sumBi_ppmDestino = 0;
          let sumCd_ppmDestino = 0;
          let sumZn_pctDestino = 0;
          let sumAuEq_OzDestino = 0;

          Object.entries(grupoDestino.dataOrigenes || {}).forEach(
            ([origenKey, grupoOrigen]) => {
              const registros = grupoOrigen.registros;

              let totalToneladas = 0;
              let sumAuEq_Gr_t = 0;
              let sumAu_Gr_t = 0;
              let sumAg_gr_t = 0;
              let sumCu_pct = 0;
              let sumFe_pct = 0;
              let sumS_pct = 0;
              let sumAs_pct = 0;
              let sumBi_ppm = 0;
              let sumCd_ppm = 0;
              let sumZn_pct = 0;
              let sumAuEq_Oz = 0;

              registros.forEach((registro) => {
                const toneladas = Number(registro[13]) || 0;
                const auEq_Gr_t = Number(registro[16]) || 0;

                totalToneladas += toneladas;
                sumAu_Gr_t += toneladas * Number(registro[17]) || 0;
                sumAg_gr_t += toneladas * (Number(registro[19]) || 0);
                sumCu_pct += toneladas * (Number(registro[20]) || 0);
                sumAuEq_Gr_t += toneladas * auEq_Gr_t;
                sumFe_pct += toneladas * (Number(registro[21]) || 0);
                sumS_pct += toneladas * (Number(registro[26]) || 0);
                sumAs_pct += toneladas * (Number(registro[22]) || 0);
                sumBi_ppm += toneladas * (Number(registro[23]) || 0);
                sumCd_ppm += toneladas * (Number(registro[24]) || 0);
                sumZn_pct += toneladas * (Number(registro[25]) || 0);
                sumAuEq_Oz += toneladas * auEq_Gr_t;

                // Agrega AuEq_Oz individual
                const AuEqOzIndividual =
                  toneladas && auEq_Gr_t
                    ? ((toneladas * auEq_Gr_t) / 31.1035).toFixed(2)
                    : "0.0";
                registro.push(AuEqOzIndividual);
              });

              const dividir = (total) =>
                totalToneladas ? (total / totalToneladas).toFixed(2) : "0.00";
              const dividirSiError = (total) =>
                totalToneladas > 0 && total > 0
                  ? (total / 31.1035).toFixed(2)
                  : "0.00";

              origenesCalculados.push({
                Origenes: grupoOrigen.Origenes,
                Toneladas: totalToneladas.toFixed(2),
                AuEq_Gr_t: dividir(sumAuEq_Gr_t),
                Au_Gr_t: dividir(sumAu_Gr_t),
                Ag_gr_t: dividir(sumAg_gr_t),
                Cu_pct: dividir(sumCu_pct),
                Fe_pct: dividir(sumFe_pct),
                S_pct: dividir(sumS_pct),
                As_pct: dividir(sumAs_pct),
                Bi_ppm: dividir(sumBi_ppm),
                Cd_ppm: dividir(sumCd_ppm),
                Zn_pct: dividir(sumZn_pct),
                AuEq_Oz: dividirSiError(sumAuEq_Oz),
                registros: registros,
              });

              // Acumular para el destino
              totalToneladasDestino += totalToneladas;
              sumAu_Gr_tDestino += sumAu_Gr_t;
              sumAg_gr_tDestino += sumAg_gr_t;
              sumCu_pctDestino += sumCu_pct;
              sumAuEq_Gr_tDestino += sumAuEq_Gr_t;
              sumFe_pctDestino += sumFe_pct;
              sumS_pctDestino += sumS_pct;
              sumAs_pctDestino += sumAs_pct;
              sumBi_ppmDestino += sumBi_ppm;
              sumCd_ppmDestino += sumCd_ppm;
              sumZn_pctDestino += sumZn_pct;
              sumAuEq_OzDestino += sumAuEq_Oz;
            }
          );

          const dividirDestino = (total) =>
            totalToneladasDestino
              ? (total / totalToneladasDestino).toFixed(2)
              : "0.00";
          const dividirDestinoSiError = (total) =>
            totalToneladasDestino > 0 && total > 0
              ? (total / 31.1035).toFixed(2)
              : "0.00";

          destinosCalculados.push({
            Destinos: grupoDestino.Destinos,
            Toneladas: totalToneladasDestino.toFixed(2),
            AuEq_Gr_t: dividirDestino(sumAuEq_Gr_tDestino),
            Au_Gr_t: dividirDestino(sumAu_Gr_tDestino),
            Ag_gr_t: dividirDestino(sumAg_gr_tDestino),
            Cu_pct: dividirDestino(sumCu_pctDestino),
            Fe_pct: dividirDestino(sumFe_pctDestino),
            S_pct: dividirDestino(sumS_pctDestino),
            As_pct: dividirDestino(sumAs_pctDestino),
            Bi_ppm: dividirDestino(sumBi_ppmDestino),
            Cd_ppm: dividirDestino(sumCd_ppmDestino),
            Zn_pct: dividirDestino(sumZn_pctDestino),
            AuEq_Oz: dividirDestinoSiError(sumAuEq_OzDestino),
            dataOrigenes: origenesCalculados,
          });

          // Acumular para la fecha
          totalToneladasFecha += totalToneladasDestino;
          sumAu_Gr_tFecha += sumAu_Gr_tDestino;
          sumAg_gr_tFecha += sumAg_gr_tDestino;
          sumCu_pctFecha += sumCu_pctDestino;
          sumAuEq_Gr_tFecha += sumAuEq_Gr_tDestino;
          sumFe_pctFecha += sumFe_pctDestino;
          sumS_pctFecha += sumS_pctDestino;
          sumAs_pctFecha += sumAs_pctDestino;
          sumBi_ppmFecha += sumBi_ppmDestino;
          sumCd_ppmFecha += sumCd_ppmDestino;
          sumZn_pctFecha += sumZn_pctDestino;
          sumAuEq_OzFecha += sumAuEq_OzDestino;
        }
      );

      const dividirFecha = (total) =>
        totalToneladasFecha ? (total / totalToneladasFecha).toFixed(2) : "0.00";
      const dividirFechaSiError = (total) =>
        totalToneladasFecha > 0 && total > 0
          ? (total / 31.1035).toFixed(2)
          : "0.00";

      resultado.push({
        Etiquetas_de_fila: grupoFecha.Etiquetas_de_fila,
        Toneladas: totalToneladasFecha.toFixed(2),
        AuEq_Gr_t: dividirFecha(sumAuEq_Gr_tFecha),
        Au_Gr_t: dividirFecha(sumAu_Gr_tFecha),
        Ag_gr_t: dividirFecha(sumAg_gr_tFecha),
        Cu_pct: dividirFecha(sumCu_pctFecha),
        Fe_pct: dividirFecha(sumFe_pctFecha),
        S_pct: dividirFecha(sumS_pctFecha),
        As_pct: dividirFecha(sumAs_pctFecha),
        Bi_ppm: dividirFecha(sumBi_ppmFecha),
        Cd_ppm: dividirFecha(sumCd_ppmFecha),
        Zn_pct: dividirFecha(sumZn_pctFecha),
        AuEq_Oz: dividirFechaSiError(sumAuEq_OzFecha),
        dataDestinos: destinosCalculados,
      });
    });

    return resultado;
  }


  //calcula los ponderados finales (resumen)
  function resumenPonderadosCalculados(agrupado) {

    let totalToneladas = 0;
    let sumAuEq_Gr_t = 0;
    let sumAu_Gr_t = 0;
    let sumAg_gr_t = 0;
    let sumCu_pct = 0;
    let sumFe_pct = 0;
    let sumS_pct = 0;
    let sumAs_pct = 0;
    let sumBi_ppm = 0;
    let sumCd_ppm = 0;
    let sumZn_pct = 0;
    let sumAuEq_Oz = 0;

    agrupado.forEach((item, index) => {
      const toneladas = Number(item.Toneladas) || 0;
      const auEq_Gr_t = Number(item.AuEq_Gr_t) || 0;
      totalToneladas += toneladas;

      sumAu_Gr_t += toneladas * (Number(item.Au_Gr_t) || 0); //='Au * tons'/Toneladas
      sumAg_gr_t += toneladas * (Number(item.Ag_gr_t) || 0); //='Ag * tons'/Toneladas

      sumCu_pct += toneladas * (Number(item.Cu_pct) || 0); //='Cu% * tons '/Toneladas
      sumAuEq_Gr_t += toneladas * auEq_Gr_t; //='AuEq * tons'/Toneladas
      sumFe_pct += toneladas * (Number(item.Fe_pct) || 0); //='Fe * tons'/Toneladas

      sumS_pct += toneladas * (Number(item.S_pct) || 0); //='S% * tons'/Toneladas
      sumAs_pct += toneladas * (Number(item.As_pct) || 0); //='AS*T'/Toneladas
      sumBi_ppm += toneladas * (Number(item.Bi_ppm) || 0); //='Bi*t'/Toneladas
      sumCd_ppm += toneladas * (Number(item.Cd_ppm) || 0); //='Cd*t'/Toneladas
      sumZn_pct += toneladas * (Number(item.Zn_pct) || 0); //='Zn*t'/Toneladas
      sumAuEq_Oz += toneladas * auEq_Gr_t; //= SI.ERROR(('AuEq Gr/t '*Toneladas)/31.1035,0)
    });

    const dividir = (total) =>
      totalToneladas ? (total / totalToneladas).toFixed(2) : "0.00";
    const dividirSiError = (total) =>
      totalToneladas > 0 && total > 0 ? (total / 31.1035).toFixed(2) : "0.00";

    let result = {
      Toneladas: totalToneladas.toFixed(2),
      AuEq_Gr_t: dividir(sumAuEq_Gr_t),
      Au_Gr_t: dividir(sumAu_Gr_t),
      Ag_gr_t: dividir(sumAg_gr_t),
      Cu_pct: dividir(sumCu_pct),
      Fe_pct: dividir(sumFe_pct),
      S_pct: dividir(sumS_pct),
      As_pct: dividir(sumAs_pct),
      Bi_ppm: dividir(sumBi_ppm),
      Cd_ppm: dividir(sumCd_ppm),
      Zn_pct: dividir(sumZn_pct),
      AuEq_Oz: dividirSiError(sumAuEq_Oz),
    };

    return result;
  }
 
  const handleMovimientos = (event) => {
    const value = event.target.value;
    const seleccionados = typeof value === "string" ? value.split(",") : value;

    const totalSinTodos = dataMovimientos.filter((d) => d !== "TODOS");
    const seleccionSinTodos = seleccionados.filter((v) => v !== "TODOS");

    // Caso 1: Si se hace clic en "TODOS"
    if (seleccionados.includes("TODOS")) {
      const isAllSelected = movimientos.length === totalSinTodos.length;
      const nuevosValores = isAllSelected ? [] : totalSinTodos;
      setMovimientos(nuevosValores);
      setFiltrosSeleccionados((prev) => ({
        ...prev,
        movimientos: nuevosValores,
      }));
      return;
    }

    // Caso 2: Selección normal (quitar uno, agregar uno)
    setMovimientos(seleccionSinTodos);

    setFiltrosSeleccionados((prev) => ({
      ...prev,
      movimientos: seleccionSinTodos,
    }));
  };


  const handleDesarrollos = (event) => {
    const value = event.target.value;
    const seleccionados = typeof value === "string" ? value.split(",") : value;

    const totalSinTodos = dataDesarrollos.filter((d) => d !== "TODOS");
    const seleccionSinTodos = seleccionados.filter((v) => v !== "TODOS");

    // Caso 1: Si se hace clic en "TODOS"
    if (seleccionados.includes("TODOS")) {
      const isAllSelected = desarrollos.length === totalSinTodos.length;
      const nuevosValores = isAllSelected ? [] : totalSinTodos;
      setDesarrollos(nuevosValores);
      setFiltrosSeleccionados((prev) => ({
        ...prev,
        desarrollos: nuevosValores,
      }));
      return;
    }

    // Caso 2: Selección normal (quitar uno, agregar uno)
    setDesarrollos(seleccionSinTodos);

    setFiltrosSeleccionados((prev) => ({
      ...prev,
      desarrollos: seleccionSinTodos,
    }));
  };

  const handleMateriales = (event) => {
    const value = event.target.value;
    const seleccionados = typeof value === "string" ? value.split(",") : value;

    const totalSinTodos = dataMateriales.filter((d) => d !== "TODOS");
    const seleccionSinTodos = seleccionados.filter((v) => v !== "TODOS");

    // Caso 1: Si se hace clic en "TODOS"
    if (seleccionados.includes("TODOS")) {
      const isAllSelected = materiales.length === totalSinTodos.length;
      const nuevosValores = isAllSelected ? [] : totalSinTodos;
      setMateriales(nuevosValores);
      setFiltrosSeleccionados((prev) => ({
        ...prev,
        materiales: nuevosValores,
      }));
      return;
    }

    // Caso 2: Selección normal (quitar uno, agregar uno)
    setMateriales(seleccionSinTodos);

    setFiltrosSeleccionados((prev) => ({
      ...prev,
      materiales: seleccionSinTodos,
    }));
  };

  const tablaRender = useMemo(() => {
    return <FourthCollapsibleTable rows={finalData} resumenPonderados={resumenPonderados}/>;
  }, [finalData]);

  
  const exportToExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(finalData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Datos");
    XLSX.writeFile(workbook, `ProduccionDiariaOrePass.xlsx`);
  };

  return (
    <div className="p-4 rounded-lg shadow-lg  bg-ceniza_light border-gray-600 mt-1 w-full">
      {/* Loader */}
      <Backdrop
        sx={(theme) => ({ color: "#fff", zIndex: theme.zIndex.drawer + 1 })}
        open={openLoader}
      >
        <CircularProgress color="inherit" />
      </Backdrop>

      <div  className="grid grid-cols-3">
        <DateTimePicker
          filtrosSeleccionados={filtrosSeleccionados}
          setFiltrosSeleccionados={setFiltrosSeleccionados}
        />
         <MultiSelect
          label="Movimientos"
          data={dataMovimientos}
          items={movimientos}
          handleChange={handleMovimientos}
        />
        <MultiSelect
            label="Desarrollo"
            data={dataDesarrollos}
            items={desarrollos}
            handleChange={handleDesarrollos}
        />
        <MultiSelect
          label="Materiales"
          data={dataMateriales}
          items={materiales}
          handleChange={handleMateriales}
        />

        <div></div>

        <Button
          onClick={() => exportToExcel()}
          variant="contained"
          sx={{ ...MainButton, width: "120px", marginTop: "40px" }}
          endIcon={<CloudDownloadIcon />}
        >
          Exportar
        </Button>

      </div>

      <div className="mt-3 h-[60vh] overflow-y-auto">
        {tablaRender}
      </div>
    </div>
  );
}

export default FourthDynamicTable;
